import { db } from '../../firebase/config';
import fetchOwnAdress from './fetchOwnAdress';
import { client } from '../../hooks/Client';
import shouldAutoMarkCompleted from './shouldAutoMarkCompleted';
import recordStatusChange from '../statusHistory/recordStatusChange';

/**
 * Zet het huishouden van een zojuist afgerond huisbezoek op 'Afgerond'.
 *
 * Spiegel van `autoMarkAdressPlanned`, inclusief de reden om het huishouden hier
 * VERS op te halen: de beslissing gaat over de status van dit moment en niet
 * over een momentopname uit een hook die al even open staat.
 * AI-CONTEXT: See docs/patterns.md#data-fresh-fetch-on-mutation
 *
 * De aanroeper beslist óf dit mag (de instelling per organisatie); deze functie
 * beslist alleen of het kán.
 *
 * @param {object|null|undefined} task - Het opgeslagen taakdocument
 * @param {string} [changedBy] - Users.ID van wie het bezoek afrondde
 * @returns {Promise<boolean>} true als de status is gewijzigd
 */
const autoMarkAdressCompleted = async (task, changedBy) => {
    // Eerst de taak zelf, ook om de .where() te behoeden voor een ontbrekend
    // AdressID of een lege client.
    if (!client) return false;
    if (!shouldAutoMarkCompleted(task, '')) return false;

    // Eén leespad voor 'mijn eigen huishouden': eigen organisatie, ID-veld,
    // niet verwijderd. AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
    const doc = await fetchOwnAdress(task.AdressID);
    if (!doc) return false;
    const previousStatus = doc.data().Status;
    if (!shouldAutoMarkCompleted(task, previousStatus)) return false;

    await db.collection('Adresses').doc(doc.id).update({ Status: 'completed' });
    await recordStatusChange({
        entityType: 'adress',
        entityID: task.AdressID,
        fromStatus: previousStatus,
        toStatus: 'completed',
        changedBy,
    });
    return true;
};

export default autoMarkAdressCompleted;
